/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_CancelInputs */

const en_case_create_incomplete_confirm_cancel = /** @type {(inputs: Case_Create_Incomplete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue editing`)
};

const pt_br2_case_create_incomplete_confirm_cancel = /** @type {(inputs: Case_Create_Incomplete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar preenchendo`)
};

/**
* | output |
* | --- |
* | "Continue editing" |
*
* @param {Case_Create_Incomplete_Confirm_CancelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_cancel = /** @type {((inputs?: Case_Create_Incomplete_Confirm_CancelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_CancelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_cancel(inputs)
	return pt_br2_case_create_incomplete_confirm_cancel(inputs)
});